import {DepartmentNode, EntityConfigDto} from '@hconnect/common/types'

import {type FlowEntity} from '../flow'

export const mapToFlowEntities = (
  nodes: DepartmentNode[],
  plantConfigs?: EntityConfigDto[]
): FlowEntity[] => {
  const entities: FlowEntity[] = nodes.map((node) => ({
    id: node.upmId,
    label: node.displayValue!
  }))
  if (!plantConfigs) return entities
  return entities.map((entity) => {
    const config = plantConfigs.find((c) => c.metadata.typeUpmId === entity.id)
    const localName = config?.payload.productionData.find((d) => d.name === 'localName')?.value
    return localName ? {...entity, label: localName} : entity
  })
}
